import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../lib/api";
import { setCurrency } from "../lib/format";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [member, setMember] = useState(null);
  const [household, setHousehold] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setMember(data.member);
      setHousehold(data.household);
      setCurrency(data.household?.default_currency);
      return data;
    } catch {
      setUser(null);
      setMember(null);
      setHousehold(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setUser(null);
    setMember(null);
    setHousehold(null);
  };

  return (
    <AuthContext.Provider value={{ user, member, household, loading, refresh, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
